(function () {
  function initReturnRestore(root) {
    if (!root || root.dataset.pcReturnInit === '1') return;
    root.dataset.pcReturnInit = '1';

    var restoreKey = 'psylosCollectionReturn:' + window.location.pathname + window.location.search;

    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (e) {}

    root.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-pc-product-link]');
      if (!link || !root.contains(link)) return;

      var card = link.closest('[data-psylos-card]');
      var payload = {
        y: window.scrollY || window.pageYOffset || 0,
        productId: link.getAttribute('data-product-id') || '',
        ts: Date.now()
      };

      if (card) {
        var rect = card.getBoundingClientRect();
        payload.cardTop = rect.top + (window.scrollY || window.pageYOffset || 0);
      }

      try {
        sessionStorage.setItem(restoreKey, JSON.stringify(payload));
      } catch (e) {}
    });

    function shouldRestore(event) {
      if (event && event.persisted) return true;

      try {
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (nav && nav.type === 'back_forward') return true;
      } catch (e) {}

      return document.referrer.indexOf('/products/') !== -1;
    }

    function restorePosition(event) {
      if (!shouldRestore(event)) return;

      var raw = null;
      try { raw = sessionStorage.getItem(restoreKey); } catch (e) {}
      if (!raw) return;

      var saved;
      try { saved = JSON.parse(raw); } catch (e) { return; }
      if (!saved || Date.now() - saved.ts > 30 * 60 * 1000) return;

      var attempts = 0;
      var selector = saved.productId
        ? '[data-psylos-card][data-product-id="' + saved.productId + '"]'
        : '';
      var target = selector ? root.querySelector(selector) : null;
      var desiredY = typeof saved.y === 'number' ? saved.y : saved.cardTop;
      if (typeof desiredY !== 'number') desiredY = 0;

      function runRestore() {
        attempts += 1;
        window.scrollTo(0, Math.max(0, desiredY));

        if (target && attempts === 8) {
          var r = target.getBoundingClientRect();
          if (r.top < 80 || r.top > window.innerHeight * 0.75) {
            target.scrollIntoView({ block: 'center', inline: 'nearest' });
          }
        }

        if (attempts < 8) {
          window.setTimeout(runRestore, attempts < 3 ? 40 : 120);
        }
      }

      requestAnimationFrame(runRestore);
    }

    window.addEventListener('pageshow', restorePosition);
    if (document.readyState === 'complete') {
      restorePosition();
    } else {
      window.addEventListener('load', restorePosition, { once: true });
    }
  }

  function boot() {
    document.querySelectorAll('.psylos-coll').forEach(initReturnRestore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
